import { T as u, c as y, g as h, i as g, t as w } from "./index-M5QJYDAG.js";
import { i as b } from "./isType-dZyoyzn5.js";
import { i as v } from "./isClient-bZWD-rdJ.js";
import { a as x, g as T } from "./getBreakpoint-dhJSqYZr.js";
import { p as M, u as C, s as I, q as E } from "./style-ImpGK6sv.js";
import { b as S, i as k, a as D } from "./backgroundSvg-O3FYVvtM.js";
import { i as R, n as l } from "./translation-EA7nJRmX.js";
import { D as L, I as U, L as z, M as A, S as F, a as O, p as Y } from "./domPurify-ugx5Lmst.js";
import { g as _ } from "./_commonjsHelpers-OnjxAlhP.js";
import { g as j } from "./getScrollbarWidth-usY8URQC.js";
import { s as B } from "./scrollIntoViewIfNeeded-xuoxAk9g.js";
function N(s, a) {
  let r;
  return function(...t) {
    clearTimeout(r), r = setTimeout(() => {
      s.apply(this, t);
    }, a);
  };
}
const P = {
  tab: ["Tab"],
  enter: ["Enter"],
  escape: ["Escape", "Esc"],
  arrowLeft: ["ArrowLeft", "Left"],
  arrowUp: ["ArrowUp", "Up"],
  arrowRight: ["ArrowRight", "Right"],
  arrowDown: ["ArrowDown", "Down"],
  space: [" ", "Spacebar"],
  home: ["Home"],
  end: ["End"]
}, V = (s, a) => a.some((r) => P[r].some((t) => t === s.key));
function H(s, a) {
  let r = 0;
  return function(...t) {
    const e = (/* @__PURE__ */ new Date()).getTime();
    e - r < a || (r = e, s(...t));
  };
}
const c = (s) => {
  if (!s)
    return;
  const a = new Date(s);
  if (!isNaN(a.getTime()))
    return a;
}, d = (s, a, r) => {
  const t = {
    day: "numeric",
    month: r ? "long" : "short",
    year: "numeric",
    timeZone: "UTC"
  }, n = new Intl.DateTimeFormat(a, t).formatToParts(s), o = n.findIndex((m) => m.type === "day"), i = n.findIndex((m) => m.type === "month"), $ = n.findIndex((m) => m.type === "year");
  return a != null && a.includes("zh") ? {
    day: `${n[o].value}${n[o + 1].value}`,
    month: `${n[i].value}${n[i + 1].value}`,
    year: `${n[$].value}${n[$ + 1].value}`
  } : { day: `${n[o].value}`, month: `${n[i].value}`, year: `${n[$].value}` };
}, f = (s, a, r) => {
  const { day: t, month: e, year: n } = s;
  if (!a)
    return r ? `${t} ${e} ${n}` : `${t} ${e}`;
  const { day: o, month: i, year: $ } = a;
  return t === o && e === i ? r ? `${t} ${e} ${n}` : `${t} ${e}` : e === i ? r ? `${t} - ${o} ${e} ${n}` : `${t} - ${o} ${e}` : r ? `${t} ${e} ${n} - ${o} ${i} ${$}` : `${t} ${e} - ${o} ${i}`;
}, p = (s, a, r) => {
  const { day: t, month: e, year: n } = s;
  if (!a)
    return r ? `${n}${e}${t}` : `${e}${t}`;
  const { day: o, month: i, year: $ } = a;
  return t === o && e === i ? r ? `${$}${e}${t}` : `${e}${t}` : e === i ? r ? `${n}${e}${t} - ${o}` : `${e}${t} - ${o}` : r ? `${n}${e}${t} - ${$}${i}${o}` : `${e}${t} - ${i}${o}`;
}, q = (s, a, r, t) => {
  const e = c(s), n = c(a), o = e && d(e, r, t);
  if (!o)
    return "";
  const i = n && n > e ? d(n, r, t) : void 0;
  return r != null && r.includes("zh") ? p(o, i, t) : f(o, i, t);
}, at = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  DOMpurify: L,
  InlineRichtextConfig: U,
  ListicleRichtextConfig: z,
  MainRichtextConfig: A,
  SimpleTextFormattingConfig: F,
  SocialMediaEmbedsConfig: O,
  TrackingEvents: u,
  backgroundSvg: S,
  checkClick: y,
  createDateFromString: c,
  debounce: N,
  eventMatchesKeys: V,
  formatChinese: p,
  formatDate: q,
  formatEnglish: f,
  getBreakpoint: x,
  getBreakpointValue: T,
  getBrowserGlobals: _,
  getRegion: h,
  getScrollbarWidth: j,
  icons: k,
  interpolate: R,
  isClient: v,
  isDebug: g,
  isType: b,
  isValidUrl: D,
  notFoundPrefix: l,
  parseDayMonthObject: d,
  prefersContrast: M,
  purifySocialMediaEmbedsHTML: Y,
  rotate: C,
  scrollIntoViewIfNeeded: B,
  size: I,
  textEllipsis: E,
  throttle: H,
  track: w
}, Symbol.toStringTag, { value: "Module" }));
export {
  p as a,
  q as b,
  c,
  N as d,
  V as e,
  f,
  at as i,
  d as p,
  H as t
};
